/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionPromptsControllerFindOneQueryResponse, TemplateQuestionPromptsControllerFindOnePathParams, TemplateQuestionPromptsControllerFindOneQueryParams, TemplateQuestionPromptsControllerFindOne400, TemplateQuestionPromptsControllerFindOne401, TemplateQuestionPromptsControllerFindOne403, TemplateQuestionPromptsControllerFindOne404 } from "../../models/checklistsController/TemplateQuestionPromptsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templateQuestionPromptsControllerFindOne } from "../../clients/checklistsService/templateQuestionPromptsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templateQuestionPromptsControllerFindOneQueryKey = (id: TemplateQuestionPromptsControllerFindOnePathParams["id"], params: TemplateQuestionPromptsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-template-question-prompts/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TemplateQuestionPromptsControllerFindOneQueryKey = ReturnType<typeof templateQuestionPromptsControllerFindOneQueryKey>;
export function templateQuestionPromptsControllerFindOneQueryOptions(id: TemplateQuestionPromptsControllerFindOnePathParams["id"], params?: TemplateQuestionPromptsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templateQuestionPromptsControllerFindOneQueryKey(id, params);
  return queryOptions<TemplateQuestionPromptsControllerFindOneQueryResponse, ResponseErrorConfig<TemplateQuestionPromptsControllerFindOne400 | TemplateQuestionPromptsControllerFindOne401 | TemplateQuestionPromptsControllerFindOne403 | TemplateQuestionPromptsControllerFindOne404>, TemplateQuestionPromptsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templateQuestionPromptsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific checklist template question prompt by ID
 * {@link /api/v1/checklist-template-question-prompts/:id}
 */
export function useTemplateQuestionPromptsControllerFindOne<TData = TemplateQuestionPromptsControllerFindOneQueryResponse, TQueryData = TemplateQuestionPromptsControllerFindOneQueryResponse, TQueryKey extends QueryKey = TemplateQuestionPromptsControllerFindOneQueryKey>(id: TemplateQuestionPromptsControllerFindOnePathParams["id"], params?: TemplateQuestionPromptsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplateQuestionPromptsControllerFindOneQueryResponse, ResponseErrorConfig<TemplateQuestionPromptsControllerFindOne400 | TemplateQuestionPromptsControllerFindOne401 | TemplateQuestionPromptsControllerFindOne403 | TemplateQuestionPromptsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templateQuestionPromptsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...templateQuestionPromptsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplateQuestionPromptsControllerFindOne400 | TemplateQuestionPromptsControllerFindOne401 | TemplateQuestionPromptsControllerFindOne403 | TemplateQuestionPromptsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}